import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.7159 1.31585C6.4856 0.855242 6.37045 0.624939 6.21462 0.551035C6.07902 0.486721 5.9217 0.486721 5.7861 0.551034C5.63027 0.624938 5.51512 0.855242 5.28482 1.31585L4.32485 3.23578C4.25374 3.378 4.21818 3.44911 4.16617 3.50355C4.12012 3.55175 4.06491 3.59025 4.00377 3.61679C3.9347 3.64678 3.85568 3.65556 3.69765 3.67312L1.60699 3.90541C1.05494 3.96675 0.778911 3.99742 0.654167 4.12469C0.545761 4.2353 0.494726 4.38989 0.515976 4.54329C0.54043 4.71982 0.743946 4.9088 1.15098 5.28676L2.75367 6.77497C2.89261 6.90399 2.96208 6.96849 3.00223 7.04667C3.03772 7.11576 3.05662 7.19217 3.05743 7.26984C3.05836 7.35772 3.02697 7.44717 2.96419 7.62608L2.21508 9.76105C2.01059 10.3439 1.90834 10.6353 1.97624 10.8082C2.03514 10.9582 2.16273 11.0706 2.31896 11.1102C2.49908 11.1558 2.7753 11.0177 3.32773 10.7415L5.64259 9.58403C5.77377 9.51844 5.83936 9.48564 5.90816 9.47274C5.96909 9.4613 6.03162 9.4613 6.09256 9.47274C6.16136 9.48564 6.22695 9.51844 6.35813 9.58403L8.67298 10.7415C9.22542 11.0177 9.50163 11.1558 9.68175 11.1102C9.83798 11.0706 9.96558 10.9582 10.0245 10.8082C10.0924 10.6353 9.99012 10.3439 9.78563 9.76104L9.03652 7.62608C8.97375 7.44717 8.94236 7.35772 8.94328 7.26984C8.9441 7.19217 8.963 7.11576 8.99848 7.04667C9.03863 6.96849 9.1081 6.90399 9.24704 6.77497L10.8497 5.28676C11.2568 4.9088 11.4603 4.71982 11.4847 4.54329C11.506 4.38989 11.455 4.2353 11.3465 4.12469C11.2218 3.99742 10.9458 3.96675 10.3937 3.90541L8.30306 3.67312C8.14503 3.65556 8.06601 3.64678 7.99694 3.61679C7.9358 3.59025 7.88059 3.55175 7.83454 3.50355C7.78253 3.44911 7.74697 3.378 7.67586 3.23578L6.7159 1.31585Z",
  fill: "url(#paint0_linear_3456_62713)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "paint0_linear_3456_62713",
    x1: "6.00036",
    y1: "-0.115234",
    x2: "6.00036",
    y2: "11.6247",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#F5CF37" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#EEAD12"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }